<template>
  <div class="content-charts">
    <div class="chart">
      <DxChart
        id="soil_needs_N"
        ref="chart1"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="bar"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS ? 'soil_needs_N_fixed' : 'soil_needs_N'"
          name="Periodo"
          -dx-argument-axis
          :value-margins-enabled="true"
        />
        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle text="[N] (mmol/L)" />
        </DxValueAxis>
        <DxArgumentAxis
          title="Periodo"
        />
        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle text="N" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltip"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Abonado - N`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>
    <div
      v-if="showColumnByCrop"
      class="chart"
    >
      <DxChart
        id="chart"
        ref="chart2"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="bar"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS ? 'soil_needs_P_fixed' : 'soil_needs_P'"
          name="Periodo"
        />
        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle text="[P] (mmol/L)" />
        </DxValueAxis>
        <DxArgumentAxis
          :value-margins-enabled="true"

          title="Periodo"
        />
        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle text="P" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltip"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Abonado - P`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>
    <div
      v-if="showColumnByCrop"
      class="chart"
    >
      <DxChart
        id="chart"
        ref="chart3"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="bar"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS ? 'soil_needs_K_fixed' : 'soil_needs_K'"
          name="Periodo"
        />

        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle text="[K] (mmol/L)" />
        </DxValueAxis>
        <DxArgumentAxis
          :value-margins-enabled="true"

          title="Periodo"
        />
        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle text="K" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltip"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Abonado - K`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>
    <div
      v-if="showColumnByCrop"
      class="chart"
    >
      <DxChart
        id="chart"
        ref="chart4"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="bar"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS ? 'soil_needs_Ca_fixed' : 'soil_needs_Ca'"
          name="Periodo"
        />

        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle text="[Ca] (mmol/L)" />
        </DxValueAxis>
        <DxArgumentAxis
          :value-margins-enabled="true"

          title="Periodo"
        />
        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle text="Ca" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltip"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Abonado - Ca`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>
    <div
      v-if="showColumnByCrop"
      class="chart"
      style="padding-bottom: 2rem;"
    >
      <DxChart
        id="chart"
        ref="chart5"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="bar"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS ? 'soil_needs_Mg_fixed' : 'soil_needs_Mg'"
          name="Periodo"
        />
        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle
            text="[Mg] (mmol/L)"
          />
        </DxValueAxis>
        <DxArgumentAxis
          :value-margins-enabled="true"
          title="Periodo"
        />
        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle :text="'Mg'" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltip"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Abonado - Mg`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>
    <div
      v-if="DEVICE_PLATFORM !== 'android'"
      class="controls-pane"
      style="width: 100%; padding-bottom: 1rem;"
    >
      <DxButton
        id="export"
        style="background-color: #616B7C; padding: 0.5rem;"
        icon="export"
        type="default"
        :text="$t('exportGraphs')"
        @click="onClickExport()"
      />
    </div>
  </div>
</template>
<script>
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxLegend,
  DxTitle,
  DxTooltip,
  DxScrollBar,
  DxZoomAndPan,
  DxExport, DxValueAxis,
} from 'devextreme-vue/chart';
import DxButton from 'devextreme-vue/button';
import { exportWidgets } from 'devextreme/viz/export';
import { mapState } from 'vuex';
import { DEVICE_PLATFORM, NUMBER_OF_DECIMALS, TO_FIXED_DECIMALS_IN_GRAPHICS } from '../../../js/constants';

export default {
  name: 'ChartLineManureData',
  components: {
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxLegend,
    DxTitle,
    DxTooltip,
    DxScrollBar,
    DxZoomAndPan,
    DxExport,
    DxValueAxis,
    DxButton,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    nData: {
      type: Array,
      default: () => [],
    },
    pData: {
      type: Array,
      default: () => [],
    },
    kData: {
      type: Array,
      default: () => [],
    },
    caData: {
      type: Array,
      default: () => [],
    },
    mgData: {
      type: Array,
      default: () => [],
    },
    keyName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TO_FIXED_DECIMALS_IN_GRAPHICS,
      NUMBER_OF_DECIMALS,
      nPeriods: 31,
      DEVICE_PLATFORM,
    };
  },
  computed: {
    showColumnByCrop() {
      if (this.resultProject && this.resultProject.cultive) {
        switch (this.resultProject.cultive.crop_name) {
          case 'Sandía':
          case 'Berenjena':
          case 'Calabacín':
            return false;
          default:
            return true;
        }
      }
      return true;
    },
    ...mapState('Result', [
      'resultProject',
    ]),
  },
  methods: {
    customizeTooltip(pointInfo) {
      return {
        html: `<div><div class='tooltip-header'></div><div class='tooltip-body'>
          <span class='bold'>Periodo: </span>${pointInfo.argument}
          </span> </div>
          <span class="bold">mmol/L: </span> ${Number(pointInfo.valueText).toFixed(this.NUMBER_OF_DECIMALS)}
        </span> </div></div></div>`,
      };
    },
    onLegendClick({ target: series }) {
      if (series.isVisible()) {
        series.hide();
      } else {
        series.show();
      }
    },
    onClickExport() {
      const chart1 = this.$refs.chart1.instance;
      const chart2 = this.$refs.chart2.instance;
      const chart3 = this.$refs.chart3.instance;
      const chart4 = this.$refs.chart4.instance;
      const chart5 = this.$refs.chart5.instance;

      if (DEVICE_PLATFORM === 'android') {
        this.$refs.chart1.instance.exportTo(`${this.resultProject.name} - Abonado - N`, 'png');
        this.$refs.chart2.instance.exportTo(`${this.resultProject.name} - Abonado - P`, 'png');
        this.$refs.chart3.instance.exportTo(`${this.resultProject.name} - Abonado - K`, 'png');
        this.$refs.chart4.instance.exportTo(`${this.resultProject.name} - Abonado - Ca`, 'png');
        this.$refs.chart5.instance.exportTo(`${this.resultProject.name} - Abonado - Mg`, 'png');
      } else {
        exportWidgets([[chart1, chart2, chart3, chart4, chart5]], {
          fileName: `${this.resultProject.name} - RESULTADOS ABONADO`,
          format: 'PNG',
        });
      }
    },
    onFileSaving(e) {
      if (DEVICE_PLATFORM === 'android') {
        cordova.plugins.saveDialog.saveFile(e.data, `${e.fileName}.${e.format}`).then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../chartManure/chartManure.scss";
</style>
